var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocuments = function SvgDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727589",
    fillRule: "nonzero",
    d: "M25.583 22.594v-9.451H17.73c-1 0-1.812-.816-1.812-1.822V3.43h-12.5V32.57h17.706c.134.85.376 1.665.71 2.429H2.813C1.812 35 1 34.184 1 33.179V2.82C1 1.816 1.812 1 2.813 1h14.916c1 0 2.398.588 3.097 1.29l5.89 5.92C27.415 8.912 28 10.316 28 11.32v10.137a9.956 9.956 0 0 0-2.417 1.136zM18.333 3.58v7.134h7.1c-.114-.322-.284-.645-.416-.778l-5.91-5.938c-.132-.133-.453-.304-.774-.418zm18.042 27.41a.653.653 0 0 0-.188-.47l-4.718-4.718a.653.653 0 0 0-.469-.187.653.653 0 0 0-.469.187l-4.718 4.719a.653.653 0 0 0-.188.469c0 .177.063.343.188.468l.947.948a.653.653 0 0 0 .47.188.653.653 0 0 0 .468-.188l1.969-1.968v5.229c0 .364.302.666.666.666h1.334a.671.671 0 0 0 .666-.666v-5.23l1.97 1.97a.663.663 0 0 0 .468.197.663.663 0 0 0 .469-.198l.947-.948a.653.653 0 0 0 .188-.468zM39 31c0 4.417-3.583 8-8 8s-8-3.583-8-8 3.583-8 8-8 8 3.583 8 8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documents.84be8526.svg";
export { ForwardRef as ReactComponent };